export const dashboardBoardsTour = {
  key: "dashboardBoards",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="dash-boards-list"]',
      content: t("Tour_Dashboard_BoardsList"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="dash-new-board"]',
      content: t("Tour_Dashboard_NewBoard"),
      placement: "bottom",
    },
    {
      target: '[data-tour="dash-board-card"]',
      content: t("Tour_Dashboard_BoardCard"),
      placement: "top",
    },
    {
      target: '[data-tour="dash-search"]',
      content: t("Tour_Dashboard_Search"),
      placement: "bottom",
    },
  ],
};
